import React from 'react';
import propTypes from 'prop-types';
import { LinkAsButton } from '@johnlewispartnership/wtr-ingredients/ingredients/LinkAsButton';
import { Typography } from '@johnlewispartnership/wtr-ingredients/foundations/typography';
import Success from '@johnlewispartnership/wtr-ingredients/dist/Icon/Success';
import { formatAsLongDate } from '../../../../utils/dates/format';
import styles from './index.module.scss';
const SubmissionSuccess = ({ competitionEndDate }) => (React.createElement("div", { id: "competition-success-message", className: styles.card },
    React.createElement(Success, { className: styles.icon }),
    React.createElement("div", { className: styles.spacer, "data-testid": "competition-submit-title" },
        React.createElement(Typography, { styleAs: "screenHeading", element: "h3" }, "We've received your entry")),
    React.createElement("div", { className: styles.spacer },
        React.createElement(Typography, { styleAs: "paragraph", element: "p" },
            "You can sit back and relax. The competition will end on",
            ' ',
            formatAsLongDate(competitionEndDate),
            ". We will let you know shortly afterwards if you've been successful. In the meantime, why not enter another competition?")),
    React.createElement("div", { className: styles.spacer },
        React.createElement(LinkAsButton, { label: "View all competitions", href: "/ecom/content/competitions", theme: "primary", width: "standard" }))));
SubmissionSuccess.propTypes = {
    competitionEndDate: propTypes.string.isRequired,
};
export default SubmissionSuccess;
//# sourceMappingURL=index.js.map